"use strict";

module.exports = require("./GoogleDrive.js");